import Model from "./Model";
import Treatment from './Treatment';
import { ClassTransformOptions, plainToClass, Type } from "class-transformer";

class TreatmentSession extends Model {
    id: number;
    treatment_id: number;
    name: string;
    payment: number;
    date: string;
    comment: string;
    @Type(() => Date)
    created_at: Date;
    @Type(() => Date)
    updated_at: Date;

    /*
    |--------------------------------------------------------------------------
    | Reflection
    |--------------------------------------------------------------------------
    */

    /**
     * Gets class name
     * survives minification/uglification
     *
     * @return {string}
     */
    getClassName(): string {
        return 'TreatmentSession';
    }

    /*
    |--------------------------------------------------------------------------
    | Relationships
    |--------------------------------------------------------------------------
    */

    @Type(() => Treatment)
    treatment: Treatment;

    /*
    |--------------------------------------------------------------------------
    | Methods
    |--------------------------------------------------------------------------
    */

    /**
     * Get formated date.
     *
     * @returns {string}
     */
    getDate(format = 'DD/MM/YYYY'): string {
        return this.date ? window.moment(this.date).format(format) : null;
    }

    /**
     * Created date
     *
     * @param {string} format
     * @return {string}
     */
    createdAt(format: string = 'DD/MM/YYYY HH:mm'): string {
        return window.moment(this.created_at).format(format);
    }

    /**
     * Created date
     *
     * @param {string} format
     * @return {string}
     */
    updatedAt(format: string = 'DD/MM/YYYY HH:mm'): string {
        return window.moment(this.created_at).format(format);
    }

    /**
     * Converts plain (literal) object to class (constructor) object. Also works with arrays.
     */
    static new(plain: [], options?: ClassTransformOptions): TreatmentSession[];
    static new(plain: {}, options?: ClassTransformOptions): TreatmentSession;
    static new(plain: {} | [], options?: ClassTransformOptions): TreatmentSession | TreatmentSession[] {
        return plainToClass(TreatmentSession, plain as any, options);
    }

}

export default TreatmentSession;
